import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DISPLAY_STATUS } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { IModule } from 'src/app/interfaces/resource';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { pushToObject } from 'src/app/services/convert.service';

@Component({
  selector: 'app-training-skill',
  templateUrl: './training-skill.component.html',
  styleUrls: ['./training-skill.component.scss']
})
export class TrainingSkillComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  displayStatus = DISPLAY_STATUS
  tabs = TABS.MODULE;


  LESSON_KEY: any;
  LESSON: any = {};

  loading: boolean = true;
  queryParams: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: ResourceStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }

  async ngOnInit() {
    this.route.queryParams.subscribe(queryParams => {
      this.queryParams = queryParams;
    })
    this.route.params.subscribe(async (param) => {
      this.LESSON_KEY = param['id']
      const { selectedCompanyKey } = this.auth;
      const doc = await this.ds.lessonColRef().doc(this.LESSON_KEY).get().toPromise();
      if (!doc.exists) {
        this.router.navigate(['/modules']);
        return;
      }
      this.LESSON = pushToObject(doc);
      this.store.fetchData(COLLECTION_NAME.MODULE, 2, selectedCompanyKey, this.LESSON_KEY, null, null, null, null, res => {
        this.loading = false;
      })
    })
  }

  ngOnDestroy() {
    const { fetchDataRef } = this.store;
    fetchDataRef && fetchDataRef.unsubscribe();
  }

  createActivity(item: IModule) {
    const { activityKey } = item;
    this.router.navigate([`/modules/activity-type/${item.activityTypeKey}/${item.default_skill}/${item.key}/${activityKey ? activityKey : 'draft'}`],{ queryParams: this.queryParams })
  }

  showActivity(item: IModule) {
    const { activityKey } = item;
    this.router.navigate([`/modules/activity-type/${item.activityTypeKey}/${item.default_skill}/${item.key}/${activityKey ? activityKey : 'draft'}`], { queryParams: this.queryParams })
  }

  create(item?: any) {
    this.router.navigate([`/modules/${this.LESSON_KEY}/form/${item ? item.key : 'draft'}`],{ queryParams: this.queryParams })
  }

  goBack() {
    const { id } = this.queryParams;
    this.router.navigate([`/modules/${id || 'submitted'}`])
  }

  delete(item) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: item.name, title: 'Delete Module' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.deleteModule(item, (success, res) => {
          this.snackBar.open("Module has been deleted successful.", "Done", { duration: 1000 });
        })
      }
    })
  }

}
